module.exports = __webpack_public_path__ + "static/media/logo.bdaff179.png";